import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Stack } from '@mui/material';
import { type ReactNode } from 'react';

import { Text } from 'common';

import { type ScriptContextType } from '../../../ConfigFields/DynamicField/ScriptContext.ts';
import { type SharedBlockFormFieldsProps } from '../../constants.tsx';
import { SharedFlowArguments } from '../Shared/FlowArguments/SharedFlowArguments.tsx';
import { FlowVersionFormFields } from '../Shared/FlowVersion.tsx';

interface SharedSubFlowBlockFormFieldsProps extends SharedBlockFormFieldsProps {
  scriptContextType?: ScriptContextType;
  children?: ReactNode;
}

export function SharedSubFlowV2BlockFormFields(props: SharedSubFlowBlockFormFieldsProps) {
  const { fieldNamePrefix, scriptContextType, variant, allowedFlowKinds } = props;
  return (
    <Stack gap={2}>
      <FlowVersionFormFields
        fieldNamePrefix={fieldNamePrefix}
        variant={variant}
        allowedFlowKinds={allowedFlowKinds}
      >
        <Accordion defaultExpanded variant="elevation">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Text variant="heading5">Inputs</Text>
          </AccordionSummary>
          <AccordionDetails>
            <SharedFlowArguments
              fieldName={`${fieldNamePrefix}.arguments`}
              scriptContextType={scriptContextType}
            />
          </AccordionDetails>
        </Accordion>
      </FlowVersionFormFields>
    </Stack>
  );
}
